// Import the functions you need from the SDKs you need
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';

import { initializeApp } from "firebase/app";
import {getFirestore} from '@firebase/firestore';
import { getAnalytics } from "@firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnRFZHQXt_b91UXEIo0QcsVJ7Z2gLrLi8",
  authDomain: "mundo-magnifico.firebaseapp.com",
  databaseURL: "https://mundo-magnifico-default-rtdb.firebaseio.com",
  projectId: "mundo-magnifico",
  storageBucket: "mundo-magnifico.appspot.com",
  messagingSenderId: "359929563034",
  appId: "1:359929563034:web:74dd57da3604de867b5c23",
  measurementId: "G-KKP3FCGJNG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db         = getFirestore(app);
export const analytics  = getAnalytics(app);